
import React from "react";
import { Navigate } from "react-router-dom";

export default function CareersPage() {
  return <Navigate to="/jobs" replace />;
}
